import React, { useState, useRef } from "react";
import { customAxios as axios, getToken } from "../../request";
import {
  InputBox,
  Form,
  Table,
  notification,
} from "../../components/Elements/appUtils";
import { fetchBrand } from "./actions/index";
import { addBrandUrl } from "./api";
import PageHeader from "../../components/Elements/pageHeader";
import { useNavigate } from "react-router-dom";
function AddBrand() {
  let tableRef = useRef();
  const [formData, setFormData] = useState({
    brand_Name: "",
  });

  const navigate = useNavigate();
  const handleChange = (e, fieldName) => {
    const { value } = e.target;
    setFormData({
      ...formData,
      [fieldName]: value,
    });
  };

  const handleS = async (e) => {
    e.preventDefault();
    
    const response = await axios.post(addBrandUrl(), formData, getToken());
    if (response.data.success) {
      notification.success({
        message: response.data.message || "Success",
      });
      setFormData({ brand_Name: "" });
      tableRef.current.reload();
    } else {
      console.log(response.data.message,"brand data");
      notification.error({message:response.data.message});
    }
  };

  const apiRequest = (params) => {
    return new Promise(async (resolve) => {
      const data = await fetchBrand({...params});
      console.log(data);
      resolve(data)
    });
  };

  const columns = [
    {
      title: "Brand Name",
      dataIndex: "brand_Name",
      key: "brand_Name",
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 190,
      render: (val, record) => {
        return (
            <>
                <a onClick={() => {
                  navigate(`/edit-brand?_id=${record._id}`)
                }}>
                  <img src={"./edit.svg"}/>

                </a> 
              

            </>
        );
      }
  }
  ];


  return (
    <PageHeader title={"Brands"}>
      <Form>
        <div class="card">
          <div class="card-body">
            <div class="form-elements-wrapper">
              <div class="row">
                <div class="col-lg-6">
                  <InputBox title={"Brand Name"}>
                    <input
                      type="text"
                      className={"form-control"}
                      placeholder="Enter Brand Name"
                      value={formData.brand_Name}
                      onChange={(e) => handleChange(e, "brand_Name")}
                      required
                    />
                  </InputBox>
                </div>
              </div>
            </div>
            <button onClick={handleS} className="btn btn-success">
              SUBMIT DETAILS
            </button>
          </div>
        </div>
      </Form>
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <Table apiRequest={apiRequest} columns={columns} ref={tableRef} />
            </div>
          </div>
        </div>
      </div>
    </PageHeader>
  );
}

export default AddBrand;
